/** Presentacion del tablero del jefe: cuanto lleva esperando una observacion y cuantas hay de cada tipo. */
import { ageLabel } from './reviewQueue';
import type { PendingObservation } from './queries';

/** D1 guarda 'YYYY-MM-DD HH:MM:SS' en UTC. */
export function hoursSince(createdAt: string, now: number = Date.now()): number {
  const t = new Date(createdAt.includes('T') ? createdAt : `${createdAt.replace(' ', 'T')}Z`).getTime();
  return Number.isNaN(t) ? 0 : (now - t) / 3_600_000;
}

/** "hace 3 h" / "hace 2 días"; vacio si el backend aun no entrega la fecha. */
export function waitingLabel(createdAt: string | undefined, now: number = Date.now()): string {
  return createdAt ? ageLabel(hoursSince(createdAt, now)) : '';
}

export function countBySeverity(rows: Pick<PendingObservation, 'severity'>[]): { obligatorias: number; sugeridas: number } {
  const obligatorias = rows.filter((r) => r.severity === 'obligatoria').length;
  return { obligatorias, sugeridas: rows.length - obligatorias };
}
